module.exports = "/static/assets/ea52886228e4caad4743ea02af5104fc.gif";